export default {
    state: {
        language: localStorage.getItem('oseRoutesSelectedLanguage') || 'el',
        availableLanguages: ['el', 'en'],
        mode: null
    },
    mutations: {
        setLanguage: (state, language) => {
            state.language = language
            if (state.availableLanguages.includes(language)) {
                localStorage.setItem('oseRoutesSelectedLanguage', language)
            }
        },
        setMode: (state, mode) => {
            state.mode = mode
        }
    },
    actions: {
        toggleLanguage({ commit }, lang) {
            commit('setLanguage', lang)
        },
        setMode({ commit }, mode) {
            const newMode = !mode ? null : mode
            commit('setMode', newMode)
        }
    },
    getters: {
        getLanguage: state => state.language,
        getAvailableLanguages: state => state.availableLanguages,
        getMode: state => state.mode
    }
}
